module.exports = __webpack_public_path__ + "07c5e3c6cc21b8bfbeeb38f800f984d1.svg";